import { render, staticRenderFns } from "./btn-direction.vue?vue&type=template&id=44614e72&scoped=true"
import script from "./btn-direction.vue?vue&type=script&lang=ts"
export * from "./btn-direction.vue?vue&type=script&lang=ts"
import style0 from "./btn-direction.vue?vue&type=style&index=0&id=44614e72&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44614e72",
  null
  
)

export default component.exports